var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDownloadHeatmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1255",
    "data-name": "Group 1255",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.001,
    height: 40,
    viewBox: "0 0 40.001 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M.934,15.622A.933.933,0,0,1,0,14.69V5.244A5.25,5.25,0,0,1,5.245,0h9.5a.933.933,0,0,1,0,1.865h-9.5A3.382,3.382,0,0,0,1.867,5.244V14.69A.933.933,0,0,1,.934,15.622Z",
    transform: "translate(-0.001 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M14.747,111.92h-9.5A5.249,5.249,0,0,1,0,106.678V97.233a.933.933,0,1,1,1.865,0v9.445a3.382,3.382,0,0,0,3.379,3.378h9.5a.933.933,0,1,1,0,1.865Z",
    transform: "translate(0.001 -71.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M111.16,15.622a.933.933,0,0,1-.933-.933V5.244a3.382,3.382,0,0,0-3.378-3.379H97.462a.933.933,0,1,1,0-1.865h9.387a5.25,5.25,0,0,1,5.243,5.244V14.69A.933.933,0,0,1,111.16,15.622Z",
    transform: "translate(-72.091 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M106.848,111.92H97.461a.933.933,0,0,1,0-1.865h9.387a3.382,3.382,0,0,0,3.379-3.378V97.233a.933.933,0,1,1,1.865,0v9.445A5.249,5.249,0,0,1,106.848,111.92Z",
    transform: "translate(-72.091 -71.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_426",
    "data-name": "Line 426",
    d: "M-2.751,12.047a.933.933,0,0,1-.933-.933V-2.751a.933.933,0,0,1,.933-.933.933.933,0,0,1,.933.933V11.115A.933.933,0,0,1-2.751,12.047Z",
    transform: "translate(22.989 6.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M57.843,59.035a.93.93,0,0,1-.659-.273L50.626,52.2a.933.933,0,0,1,1.319-1.319l5.9,5.9,5.9-5.9A.933.933,0,0,1,65.06,52.2L58.5,58.762A.93.93,0,0,1,57.843,59.035Z",
    transform: "translate(-37.605 -40.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M49.832,88.66a4.292,4.292,0,1,1-4.293-4.292,4.293,4.293,0,0,1,4.293,4.292",
    transform: "translate(-32.247 -64.009)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M85.8,102.383a5.614,5.614,0,1,1-5.614-5.614,5.614,5.614,0,0,1,5.614,5.614",
    transform: "translate(-54.693 -73.27)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M55.376,129.29a2.176,2.176,0,1,1,3.067.265,2.176,2.176,0,0,1-3.067-.265",
    transform: "translate(-41.975 -93.382)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadHeatmap);
export default __webpack_public_path__ + "static/media/icon-download-heatmap.f6e6bb98af7a2c3ab84c75ebec23bf2c.svg";
export { ForwardRef as ReactComponent };